import React from 'react';
import styled from 'styled-components';

const ColorLine = ({ color }) => (
  <svg viewBox="0 0 40 10" style={{ width: 40, height: 10 }}>
    <rect width={30} y={3} height={4} fill={color} />
  </svg>
);

const Wrapper = styled.div`
  font-family: Ubuntu,arial;
  margin-bottom: 20px;
  background: transparent;
  padding: 30px;

  .title {
    font-size: 16px;
    color: #707070;
    font-weight: 500;
    margin-bottom: 15px;
    text-align: center;
  }
  .item {
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #606060;
    width: 190px;
    float: left;
    white-space: nowrap;
  }
  .bordered {
    border: 1px #888 solid;
    padding: 10px;
    color: #707070;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: center;
  }
`;

export const ChartLegend = ({ colors, titles }) => (
  <Wrapper className="chart-legend">
    <div className="title">
      Hover over the dotted lines on the graph to see the equity retained at that point
    </div>
    <div className="bordered">
      {Object.keys(titles).map(id => (
        <div key={id} className="item">
          <ColorLine color={colors[id]} />
          {titles[id]}
        </div>
      ))}
    </div>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/ChartLegend.js